module.exports = __webpack_public_path__ + "static/banner2-507bf72191124682c1ce47a4b6532d8d.png";